module.exports = __webpack_public_path__ + "img/photo-camera.4be0d7a6.svg";